import * as app from 'durandal/app';
import * as router from 'plugins/router';

import popupModal from '@/legacy/modals/manage/popup';

export interface IModalOptions {
  fragmentUrl: string;
  modalHtmlPath: string;
  successCallback?: (any) => void;
  modalParamsCallback?: () => any;
}

export class PopupManager {
  private activateModal: ModalOptions;

  private visiblePopupModal: popupModal = null;

  private getBaseDialogUrl: () => string;

  public get baseDialogUrl(): string {
    return this.getBaseDialogUrl?.() ?? '';
  }

  public set baseDialogUrl(value: string | (() => string)) {
    if (typeof value === 'function') {
      // If the route hosting the dialog has a dynamic route segment (e.g. /foo/:name/dialog/bar),
      // the caller needs to be able to provide the _current_ pathname on the fly. We accept a
      // getter-function to enable this.
      this.getBaseDialogUrl = value;
    } else if (typeof value === 'string') {
      // However, the rest of the app sticks to constant paths, and those are fine too.
      this.getBaseDialogUrl = () => value;
    } else {
      this.getBaseDialogUrl = undefined;
    }
  }

  private modalNavigationSubscription = null;

  public modals: Array<IModalOptions> = [];

  public attached() {
    this.modalNavigationSubscription = app
      .on('router:navigation:complete')
      .then((instance, instruction, router0) => {
        // close existing modals
        if (router0.activeInstruction().fragment.indexOf('/dialog/') === -1) {
          this.closeExistingModal();
        }

        // see if we landed on any dialog page
        this.CheckModalNavigation();
      });

    this.CheckModalNavigation();
  }

  public detached() {
    this.closeExistingModal();
    if (this.modalNavigationSubscription != null) {
      this.modalNavigationSubscription.off();
      this.modalNavigationSubscription = null;
    }
  }

  public AddModal(dialogToAdd: IModalOptions) {
    this.modals.push(dialogToAdd);
  }

  public Show(fragmentUrl: string) {
    $('html, body').animate({ scrollTop: 0 }, 300);
    router.navigate(this.baseDialogUrl + fragmentUrl);
  }

  public closeExistingModal() {
    if (this.visiblePopupModal == null) {
      return;
    }

    const currentFragment = router.activeInstruction().fragment;

    if (currentFragment === this.baseDialogUrl && !this.visiblePopupModal.isClosing) {
      this.visiblePopupModal.params?.goBackCallback();
    }

    this.visiblePopupModal.Close();
    this.visiblePopupModal = null;

    $('.mainContent').slideDown(100);
  }

  private showModalWithSafeClose(modalHtmlPath: string, componentParams: any) {
    const thisPopupModal = popupModal.show(modalHtmlPath, {
      ...componentParams,
      goBackCallback: (...args) => {
        thisPopupModal.isClosing = true;
        return componentParams.goBackCallback(...args);
      },
      success: (...args) => {
        thisPopupModal.isClosing = true;
        return componentParams.success(...args);
      },
    });
    return thisPopupModal;
  }

  public CheckModalNavigation() {
    $.each(this.modals, (index, modal) => {
      if (
        router.activeInstruction().fragment.indexOf(this.baseDialogUrl + modal.fragmentUrl) === 0
      ) {
        this.closeExistingModal();

        const activateModal = modal;

        let componentParams: any = {};
        if (activateModal.modalParamsCallback != null) {
          componentParams = activateModal.modalParamsCallback();
        }

        // Allows to override the default go bakc implementation
        if (!componentParams.goBackCallback) {
          componentParams.goBackCallback = () => {
            this.GoBack();
          };
        }
        componentParams.success = (params) => {
          router.navigate(this.baseDialogUrl);
          if (activateModal.successCallback != null) {
            activateModal.successCallback(params);
          }
        };

        this.visiblePopupModal = this.showModalWithSafeClose(modal.modalHtmlPath, componentParams);
      }
    });
    if (this.visiblePopupModal != null) {
      let slideInterval = null;
      slideInterval = setInterval(() => {
        if ($('.manage-modal-host .plooto-content-wrapper').length > 0) {
          $('.mainContent').slideUp(700);
          clearInterval(slideInterval);
        }
      }, 10);
    }
  }

  // Allows you to force show a model (without any url changes)
  public forceShow(modal) {
    const activateModal = modal;

    let componentParams: any = {};
    if (activateModal.modalParamsCallback != null) {
      componentParams = activateModal.modalParamsCallback();
    }

    if (!activateModal.goBackCallback) {
      componentParams.goBackCallback = () => {
        this.GoBack();
      };
    } else {
      componentParams.goBackCallback = activateModal.goBackCallback;
    }

    if (!activateModal.success) {
      componentParams.success = (params) => {
        router.navigate(this.baseDialogUrl);
        if (activateModal.successCallback != null) {
          activateModal.successCallback(params);
        }
      };
    } else {
      componentParams.success = activateModal.success;
    }

    this.visiblePopupModal = this.showModalWithSafeClose(modal.modalHtmlPath, componentParams);
  }

  public GoBack() {
    router.navigate(this.baseDialogUrl);
  }
}
